import { TextField } from "@mui/material";
import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { UseFormRegister, FieldValues, FieldErrors, RegisterOptions } from "react-hook-form";

const InputTextArea: FC<{
    register: UseFormRegister<FieldValues>;
    errors: FieldErrors;
    id: string;
    label: string;
    options?: RegisterOptions;
    disabled?: boolean;
    defaultValue?: string;
}> = ({
    register,
    errors,
    id,
    label,
    options,
    disabled = false,
    defaultValue = "",
}) => {
    const [value, setValue] = React.useState(defaultValue);
    const { onChange: rhfOnChange, ...rhfRest } = register(id, options);

    return (
        <TextField
            sx={{
                "& .MuiInputBase-root": { backgroundColor: "white" },
                "& .MuiFormHelperText-root": { textAlign: "left", marginLeft: 0 },
            }}
            fullWidth
            multiline
            rows={7}
            label={label}
            disabled={disabled}
            error={!!errors[id]}
            value={value}
            onChange={(e) => {
                setValue(e.target.value);
                rhfOnChange(e);
            }}
            helperText={
                errors[id]?.message ||
                (options?.maxLength ? `${value.length} / ${options.maxLength}` : undefined)
            }
            inputProps={{ maxLength: options?.maxLength }}
            {...rhfRest}
        />
    );
};

export default observer(InputTextArea);
